var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fabb7d",
    d: "M9.45 20.793a2.773 2.773 0 0 1-.93-.143l-6.13-2.3C2.142 18.26 2 18.132 2 18s.142-.26.39-.35l4.487-1.666 5.33.032 4.313 1.634c.243.09.382.218.382.35s-.139.26-.382.35l-6.13 2.3a2.847 2.847 0 0 1-.94.143z",
    opacity: 1,
    "data-original": "#fabb7d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1a870",
    d: "m13.91 16.66-.58.22a3.01 3.01 0 0 1-1.03.16 2.913 2.913 0 0 1-1.02-.16l-2.34-.87-3.79 1.41c-.48.17-.55.44-.55.58s.07.41.55.58l5.38 2.02-.14.05a2.908 2.908 0 0 1-.94.14 2.845 2.845 0 0 1-.93-.14l-6.13-2.3C2.14 18.26 2 18.13 2 18s.14-.26.39-.35l4.49-1.67 5.33.04z",
    opacity: 1,
    "data-original": "#e1a870"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8e8be7",
    d: "M9.45 16.793a2.773 2.773 0 0 1-.93-.143l-6.13-2.3C2.142 14.26 2 14.132 2 14s.142-.26.39-.35l4.487-1.666 5.33.032 4.313 1.634c.243.09.382.218.382.35s-.139.26-.382.35l-6.13 2.3a2.847 2.847 0 0 1-.94.143z",
    opacity: 1,
    "data-original": "#8e8be7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7e7cce",
    d: "m13.91 12.66-.58.22a3.01 3.01 0 0 1-1.03.16 2.913 2.913 0 0 1-1.02-.16l-2.34-.87-3.79 1.41c-.48.17-.55.44-.55.58s.07.41.55.58l5.38 2.02-.14.05a2.908 2.908 0 0 1-.94.14 2.845 2.845 0 0 1-.93-.14l-6.13-2.3C2.14 14.26 2 14.13 2 14s.14-.26.39-.35l4.49-1.67 5.33.04z",
    opacity: 1,
    "data-original": "#7e7cce"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7dfad0",
    d: "M9.45 12.793a2.773 2.773 0 0 1-.93-.143l-6.13-2.3C2.142 10.26 2 10.132 2 10s.142-.26.39-.35l4.487-1.666 5.33.032L16.52 9.65c.243.09.382.218.382.35s-.139.26-.382.35l-6.13 2.3a2.847 2.847 0 0 1-.94.143z",
    opacity: 1,
    "data-original": "#7dfad0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70e1bb",
    d: "m13.91 8.66-.58.22a3.01 3.01 0 0 1-1.03.16 2.913 2.913 0 0 1-1.02-.16l-2.34-.87-3.79 1.41c-.48.17-.55.44-.55.58s.07.41.55.58l5.38 2.02-.14.05a2.908 2.908 0 0 1-.94.14 2.845 2.845 0 0 1-.93-.14l-6.13-2.3C2.14 10.26 2 10.13 2 10s.14-.26.39-.35l4.49-1.67 5.33.04z",
    opacity: 1,
    "data-original": "#70e1bb"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa82a8",
    d: "M9.451 8.794a2.762 2.762 0 0 1-.936-.145L2.388 6.35C2.14 6.26 2 6.131 2 6s.141-.259.388-.351L8.515 3.35a2.762 2.762 0 0 1 .936-.145 2.767 2.767 0 0 1 .937.145l6.127 2.298c.247.092.388.22.388.351s-.141.259-.388.351L10.388 8.65a2.763 2.763 0 0 1-.937.145z",
    opacity: 1,
    "data-original": "#fa82a8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e17597",
    d: "m5.15 6.58 5.38 2.02-.14.05a2.865 2.865 0 0 1-.94.14 2.845 2.845 0 0 1-.93-.14l-6.13-2.3C2.14 6.26 2 6.13 2 6s.14-.26.39-.35l6.13-2.3a2.845 2.845 0 0 1 .93-.14 2.908 2.908 0 0 1 .94.14l.14.05-5.38 2.02c-.48.17-.55.44-.55.58s.07.41.55.58z",
    opacity: 1,
    "data-original": "#e17597",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 2.5,
    r: 0.5,
    fill: "#fa82a8",
    opacity: 1,
    "data-original": "#fa82a8",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 10,
    r: 0.5,
    fill: "#7dfad0",
    opacity: 1,
    "data-original": "#7dfad0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 14,
    r: 0.5,
    fill: "#8e8be7",
    opacity: 1,
    "data-original": "#8e8be7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 0.5,
    fill: "#fabb7d",
    opacity: 1,
    "data-original": "#fabb7d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7e7cce",
    d: "M21.5 14a.695.695 0 0 0 .17.47.467.467 0 0 1-.17.03.5.5 0 0 1 0-1 .467.467 0 0 1 .17.03.695.695 0 0 0-.17.47z",
    opacity: 1,
    "data-original": "#7e7cce"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70e1bb",
    d: "M21.5 10a.695.695 0 0 0 .17.47.467.467 0 0 1-.17.03.5.5 0 0 1 0-1 .467.467 0 0 1 .17.03.695.695 0 0 0-.17.47z",
    opacity: 1,
    "data-original": "#70e1bb"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e17597",
    d: "M21.5 2.5a.695.695 0 0 0 .17.47.467.467 0 0 1-.17.03.5.5 0 0 1 0-1 .467.467 0 0 1 .17.03.695.695 0 0 0-.17.47z",
    opacity: 1,
    "data-original": "#e17597",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1a870",
    d: "M21.5 21.5a.695.695 0 0 0 .17.47.467.467 0 0 1-.17.03.5.5 0 0 1 0-1 .467.467 0 0 1 .17.03.695.695 0 0 0-.17.47z",
    opacity: 1,
    "data-original": "#e1a870"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M14.912 10.687a.25.25 0 0 0 .088.483.242.242 0 0 0 .088-.016l1.52-.57a.873.873 0 0 0 .464-.335h3.729a.75.75 0 1 0 0-.5h-3.729a.871.871 0 0 0-.464-.334L12.83 8l3.772-1.415c.478-.18.55-.443.55-.585s-.071-.406-.55-.585l-.847-.318 1.83-1.83a1.748 1.748 0 0 1 1.244-.517h1.97a.75.75 0 1 0 0-.5h-1.97a2.244 2.244 0 0 0-1.597.663l-1.991 1.992-4.766-1.788a3.321 3.321 0 0 0-2.049 0l-1.515.569a.25.25 0 0 0 .176.467l1.515-.568a2.856 2.856 0 0 1 1.697 0l6.127 2.298a1.5 1.5 0 0 1 .22.109.561.561 0 0 1-.22.125L10.3 8.415a2.856 2.856 0 0 1-1.697 0L2.476 6.117a1.49 1.49 0 0 1-.22-.109.56.56 0 0 1 .22-.125l3.612-1.355a.25.25 0 1 0-.176-.468L2.3 5.415c-.478.18-.55.443-.55.585s.071.406.55.585l3.776 1.416-3.772 1.414c-.482.176-.554.442-.554.585s.072.409.552.584L6.077 12l-3.773 1.415c-.482.176-.554.442-.554.585s.072.409.552.584L6.077 16l-3.773 1.415c-.482.176-.554.442-.554.585s.072.409.552.584l3.61 1.355a.242.242 0 0 0 .088.016.25.25 0 0 0 .088-.484l-3.612-1.356a1.484 1.484 0 0 1-.22-.107.562.562 0 0 1 .222-.124l4.31-1.617 1.645.617a3.04 3.04 0 0 0 1.018.159 3.107 3.107 0 0 0 1.027-.16l1.643-.616 4.312 1.617a1.328 1.328 0 0 1 .215.108.525.525 0 0 1-.216.124l-6.128 2.299a2.894 2.894 0 0 1-1.696.001l-1.52-.57a.25.25 0 1 0-.176.468l1.52.57a3.04 3.04 0 0 0 1.019.16 3.107 3.107 0 0 0 1.027-.16l4.765-1.787 1.99 1.99a2.244 2.244 0 0 0 1.597.663h1.97a.75.75 0 1 0 0-.5h-1.97a1.748 1.748 0 0 1-1.243-.517l-1.83-1.83.85-.319c.474-.176.545-.441.545-.584s-.071-.408-.545-.584L12.833 16l3.774-1.416a.873.873 0 0 0 .465-.334h3.729a.75.75 0 1 0 0-.5h-3.729a.871.871 0 0 0-.464-.334L12.833 12l1.255-.471a.25.25 0 0 0-.176-.468l-3.608 1.354a2.894 2.894 0 0 1-1.696.001l-6.132-2.3a1.484 1.484 0 0 1-.22-.108.562.562 0 0 1 .222-.124l4.31-1.616 1.64.615a3.021 3.021 0 0 0 1.023.161 3.022 3.022 0 0 0 1.025-.161l1.643-.616 4.314 1.617a1.328 1.328 0 0 1 .216.108.525.525 0 0 1-.217.124zM21.5 2.25a.25.25 0 1 1-.25.25.25.25 0 0 1 .25-.25zm0 19a.25.25 0 1 1-.25.25.25.25 0 0 1 .25-.25zm0-7.5a.25.25 0 1 1-.25.25.25.25 0 0 1 .25-.25zm-12.05-.707a3.107 3.107 0 0 0 1.028-.16l1.643-.616 4.312 1.617a1.328 1.328 0 0 1 .215.108.525.525 0 0 1-.216.124l-6.128 2.299a2.894 2.894 0 0 1-1.696.001l-6.132-2.3a1.484 1.484 0 0 1-.22-.108.562.562 0 0 1 .222-.124l4.31-1.617 1.645.617a3.04 3.04 0 0 0 1.018.159zM21.5 9.75a.25.25 0 1 1-.25.25.25.25 0 0 1 .25-.25z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLayer);
export default __webpack_public_path__ + "static/media/mainLayer.abc91d2e1cc0b8d8ede4ab4e72bb981d.svg";
export { ForwardRef as ReactComponent };